var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"store-info-cell c:row-between-center"},[_c('div',{staticClass:"store-info-label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"store-info-value"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }